import { useTranslation } from 'next-i18next'
import React, { FC, useEffect, useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { Country } from '_app/types/api'
import Select from '_app/components/Form/Select'
import { getRegionById } from '../utils/regions'

type Props = {
  country: Country | undefined;
  name: string;
};

const RegionsSelect: FC<Props> = ({ country, name }) => {
  const { t } = useTranslation('checkout')
  const { watch, reset, setValue } = useFormContext()

  const selectedRegionId = watch(name)
  const showRegions =
    country?.id !== 'PL' && !!country?.available_regions?.length

  useEffect(() => {
    if (!showRegions) {
      return
    }

    const region = getRegionById(selectedRegionId, country)
    const formValues = watch()

    reset({
      ...formValues,
      shipping_address: {
        ...formValues.shipping_address,
        region: region?.code,
      },
      billing_address: {
        ...formValues.billing_address,
        region: region?.code,
      },
    })
  }, [selectedRegionId, watch, reset, country, showRegions])

  const options = useMemo(() => {
    return country?.available_regions
        ?.map(region => ({
          value: region?.id ?? '',
          label: region?.name ?? '',
        }))
        .filter(({ value, label }) => value && label)
        .sort((regionA, regionB) =>
          (regionA?.label || '').localeCompare(regionB?.label || '')
        ) ?? []
    },[country])

  return (
    <Select
      isRequired={true}
      label={t('REGION_LABEL')}
      name={name}
      placeholder={t('REGION_PLACEHOLDER')}
      options={options}
      hidden={!showRegions}
    />
  )
}

export default RegionsSelect
